<template>
  <div
    class="mdc-checkbox-container"
    :key="label"
    v-show="!disabled">
    <div class="mdc-checkbox" :class="{ 'text-muted': disabled}">
      <slot/>

      <div class="mdc-checkbox__background">
        <svg
          class="mdc-checkbox__checkmark"
          aria-hidden="true"
          viewBox="0 0 24 24">
          <path
            class="mdc-checkbox__checkmark__path"
            fill="none"
            stroke="white"
            d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
        </svg>
        <div class="mdc-checkbox__mixedmark"/>
      </div>
    </div>
    <label
      class="mdc-checkbox-label"
      :class="{ 'text-muted': disabled}"
      :for="inputId">
      <div class="mdc-checkbox-label-text-container">
        <div class="mdc-checkbox-label-text-main">{{ label }} <span v-if="isAreaOfNeedNew" class="label label-success"> New</span></div>
      </div>
    </label>
  </div>
</template>

<script>
import moment from 'moment'
const NEW_DURATION_IN_MONTHS = 4

export default {
  name: 'PresentLevelsSubjectCheckboxWrapper',
  props: {
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dateAdded: {
      type: Date,
      default: () => null
    },
    inputId: {
      type: String,
      required: true
    }
  },
  computed: {
    isAreaOfNeedNew() {
      if (this.dateAdded instanceof Date) {
        let today = moment()
        let dateAddedMoment = moment(this.dateAdded)
        let diff = moment.duration(today.diff(dateAddedMoment))
        return diff.asMonths() <= NEW_DURATION_IN_MONTHS
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
@import '@material/checkbox/mdc-checkbox';
.mdc-checkbox-container {
  display: table;

  .mdc-checkbox {
    margin-left: -11px;

    // Remove "glow" effect from material-components-web
    &:before,
    &:after {
      opacity: 0;
    }

    &:hover,
    &:active,
    &:focus,
    &:checked {
      &:before,
      &:after {
        opacity: 0;
      }
    }

    .mdc-checkbox__background {
      border: 2px solid var(--gray-weak);
      border-radius: 4px;
    }

    &:hover {
      .mdc-checkbox__background {
        border: 2px solid var(--gray-strong);
      }
      .mdc-checkbox__native-control:checked {
       ~ .mdc-checkbox__background {
          border-color: var(--blue-hover);
          background-color: var(--blue-hover);
        }
      }
    }
  }

.mdc-checkbox__native-control {
  &:focus,
  &:active,
  &:checked {
    ~ .mdc-checkbox__background {
      &::before,
      &::after {
        opacity: 0;
      }
    }
  }

  &:checked {
    ~ .mdc-checkbox__background {
      border-color: var(--blue-default);
      background-color: var(--blue-default);
    }
  }

  &:focus,
  &:active {
    ~ .mdc-checkbox__background {
      border-color: var(--gray-strong);
      outline: solid 2px var(--gray-strong);
      outline-offset: 2px;
    }

    &:checked {
      ~ .mdc-checkbox__background {
        background-color: var(--blue-hover);
        border-color: var(--blue-hover);
        outline: solid 2px var(--blue-hover);
        outline-offset: 2px;
      }
    }
  }
}

  .mdc-checkbox-label.text-muted {
    color: #ccc;
  }

  .mdc-checkbox-label {
    display: table-cell;
    vertical-align: middle;

    .mdc-checkbox-label-text-container {
      display: table;

      .mdc-checkbox-label-text-main {
        display: table-cell;
        font-weight: normal;
        font-size: 20px;
        vertical-align: middle;

        .label {
          vertical-align: top;
          font-size: 0.5em;
          text-transform: uppercase;
        }
      }
    }
  }
}
</style>
